import stampcardService from "../services/stampcard.service";

export const getIcons = async ({ account_urn, type, theme }) => {
  const res = await stampcardService.getIcons({ account_urn, type, theme });
  return res.data;
};

export const deleteStampcard = async (data) => {
  return await stampcardService.deleteStampcard(data);
};

export const uploadIcon = async ({ data, accUrn, businessSlug }) => {
  const res = await stampcardService.uploadIcon({ data, accUrn, businessSlug });
  return res?.data?.data;
};

export const uploadLogo = async ({ data, accUrn, businessSlug }) => {
  const res = await stampcardService.uploadLogo({ data, accUrn, businessSlug });
  return res?.data?.data;
};

export const uploadBackground = async ({ data, accUrn, businessSlug }) => {
  const res = await stampcardService.uploadBackground({
    data,
    accUrn,
    businessSlug,
  });
  return res?.data?.data;
};
